webpackJsonp([181542127041897],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(24);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _ProjectDetails = __webpack_require__(27);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _ProjectHeader = __webpack_require__(28);
	
	var _ProjectHeader2 = _interopRequireDefault(_ProjectHeader);
	
	var _SingleImage = __webpack_require__(29);
	
	var _SingleImage2 = _interopRequireDefault(_SingleImage);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	__webpack_require__(344);
	
	var _mcaPreview_ = __webpack_require__(475);
	
	var _mcaPreview_2 = _interopRequireDefault(_mcaPreview_);
	
	var _mcaPreview_1600_ = __webpack_require__(476);
	
	var _mcaPreview_1600_2 = _interopRequireDefault(_mcaPreview_1600_);
	
	var _mcaWireframes = __webpack_require__(477);
	
	var _mcaWireframes2 = _interopRequireDefault(_mcaWireframes);
	
	var _mcaWireframes3 = __webpack_require__(478);
	
	var _mcaWireframes4 = _interopRequireDefault(_mcaWireframes3);
	
	var _mcaNavigation = __webpack_require__(473);
	
	var _mcaNavigation2 = _interopRequireDefault(_mcaNavigation);
	
	var _mcaAudiences = __webpack_require__(470);
	
	var _mcaAudiences2 = _interopRequireDefault(_mcaAudiences);
	
	var _mcaDesign = __webpack_require__(471);
	
	var _mcaDesign2 = _interopRequireDefault(_mcaDesign);
	
	var _mcaPageModels = __webpack_require__(474);
	
	var _mcaPageModels2 = _interopRequireDefault(_mcaPageModels);
	
	var _mcaEvents = __webpack_require__(472);
	
	var _mcaEvents2 = _interopRequireDefault(_mcaEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MCA = function (_Component) {
	  _inherits(MCA, _Component);
	
	  function MCA() {
	    _classCallCheck(this, MCA);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  MCA.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'project mca' },
	      _react2.default.createElement(_ProjectHeader2.default, {
	        heading: 'Designing a destination for continuous discovery',
	        client: 'Museum of Contemporary Art Australia'
	      }),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaPreview_1600_2.default, margin: true }),
	      _react2.default.createElement(
	        _ProjectDetails2.default,
	        {
	          client: 'Museum of Contemporary Art Australia',
	          duration: '9 months',
	          agency: 'Pollen',
	          agencylink: 'https://www.pollen.com.au/',
	          role: 'User experience designer',
	          deliverables: 'User research, site review, analytics review, information architecture, wireframes'
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Background'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In 2017, the Museum of Contemporary Art (MCA) Australia tapped Pollen to completely redesign their website.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Their website, home to their collection of more than 400 digitised works from over 300 artists, was outdated and they wanted a new platform that engaged new and existing audiences with contemporary art, artists, stories and ideas.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.mca.com.au' },
	            'Visit the new site'
	          )
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaPreview_2.default, margin: true }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Discovery'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'After our initial project context session, we dove into a series of interviews and co-design workshops with the MCA\u2019s stakeholders, audience, members, digital team, content team and Artist Advisory Group. Here, we developed a deep understanding the role the new website needed to play, and the jobs it needed to perform for its business and users.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'At this stage, I was also responsible for conducting a current-state site review, analytics review and competitor review, generating key insights that would inform the strategic directions of the new site.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaAudiences2.default, small: true, caption: 'An audiences card sort and personas workshop with the MCA\'s digital team.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Strategic Directions'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Taking our learnings from discovery, we defined a key set of principles that reflected the goals and desires of the MCA. The new website needed to:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Put the artist at the heart'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Promote and interweave artist content and interviews across the site.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Foster better content discovery'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Although the website was used by hundreds of thousands of people per year, it received only a small percentage of traffic to it\u2019s art and artist pages. We needed to create a high quality user experience that deepened audience engagement with the site and encouraged the exploration of art and artist content, and established the MCA as a content destination in its own right.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Tell all kinds of stories'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'The new platform needed to enable the MCA to tell the story of their artists and artworks in a rich a way as possible.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Offer a dynamic and immersive art experience'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'The new website needed to allow for more engaging content to form part of the overall page narrative.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Support the lifelong learner'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Better integrate educational outcomes and content into the artwork, artist, collection and exhibition contexts.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Support future growth'
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'We needed to create a more flexible platform that was easier to maintain, and that would support current and future growth.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Mapping it out'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'With the MCA happy with this direction, we then worked closely with the team to create an extensive product roadmap that detailed the requirements and goals for the new platform.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaPageModels2.default, caption: 'I was responsible for mapping out the new platform, translating an extensive product roadmap into a set of flexible modules, templates and pages.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Designing for flexibility'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I was then tasked with taking the product roadmap and translating it into a system of flexible modules and page templates that could be used consistently across the site for a wide range of content purposes.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'With such a varied audience, the MCA website needed to house a diverse range of programs, projects and content - everything from \u2018ARTBAR\u2019 to \u2018Art & Dementia\u2019.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'To ensure we met all these needs, we allocated key jobs-to-be-done against each individual page template and module we delivered.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaWireframes2.default, caption: 'I delivered a system 17 wireframes 46 modules, aligned with the site strategy and jobs-to-be-done.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'This project also saw the development of the \u201Cwireframework\u201D, a Sketch-based solution for creating low to medium fidelity component-based wireframe systems using a single symbol block. Using the wireframework, I was able to create and combine blocks into symbols that could be used to quickly build out entire pages.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaWireframes4.default, margin: true, caption: 'I created a wireframing language that enabled me to quickly build out modular pages using Sketch.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'A new visual language'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'At Pollen, Ross, ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://evanbohringer.myportfolio.com/' },
	            'Evan Bohringer'
	          ),
	          ' and ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'www.visualicecream.com.au' },
	            'Brett Walsh'
	          ),
	          ' were responsible for the concept and overall design of the new website. Evan worked closely with the MCA\u2019s design team throughout the project to establish a visual language fit for the web, and create a unique experience in the spirit of the museum\u2019s forward thinking brand and reputation.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaDesign2.default, margin: true, caption: 'Evan Bohringer created the MCA\'s new design system. Image via Pollen.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Throughout the project, I worked closely with design, development and content teams to help meet the goals of the project. I also helped solve a number of UX challenges that presented throughout the process:'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Designing for discovery'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The entire experience was designed to empower users to discover the breadth and depth of content that the MCA has to offer. We designed a range of \u2018discovery modules\u2019 that would house thoughtfully-curated content to encourage deeper exploration of the MCA website.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The site search also furthers discovery and exploration, helping users find their way across the site while deepening their engagement with the subject of their search.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Complex event scenarios'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The MCA had a number of different ways to represent exhibitions, events, recurring events and event series. I designed how events should be handled and displayed, enabling users to browse multiple dates of the same event and book from a single event page.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaEvents2.default, margin: true, caption: 'I demonstrated how the design system would work to generate recurring events and event series, as well as how the filters on the \u2018What\u2019s On\u2019 page might be used to filter specific dates.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Interaction design'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The MCA were keen to push \u201Cbest practices\u201D and implement bold interactions. The site\u2019s mega menu, for instance, took cues from the museum\u2019s cutting-edge facade. Although innovative, the unique design meant we couldn\u2019t rely on more standard sub-navigation patterns. I devised new secondary and sub-navigation patterns that were used across the website. '
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _mcaNavigation2.default, margin: true, caption: 'A wireframe of the new sub-navigation menu patterns that allow the MCA to add any number of links to a page.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Results'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'After an extensive QA and testing period, the new MCA website went live. ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.mca.com.au/' },
	            'Visit the new website'
	          ),
	          ' or ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.mca.com.au/stories-and-ideas/we-have-new-website/' },
	            'read more about the project here'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Pollen and the MCA continue to evolve the new platform to better serve their audiences and engage them with contemporary art, culture, stories and ideas.'
	        )
	      )
	    );
	  };
	
	  return MCA;
	}(_react.Component);
	
	MCA.propTypes = {
	  children: _react.PropTypes.node.isRequired
	};
	
	exports.default = MCA;
	module.exports = exports['default'];

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-audiences.86dc3421.jpg";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-design.b3d19a66.jpeg";

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-events.58a99fb1.png";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-navigation.6daee79c.gif";

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-page-models.0cebd254.jpg";

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-preview_1600.b49476ef.jpg";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-preview_1600_2.f2d8c573.jpg";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-wireframes-01.7bcedc44.jpg";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-wireframes-02.8c360527.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-mca-index-js-01b1f06039241149f2ff.js